import { render, staticRenderFns } from "./repairDetailPhotos.vue?vue&type=template&id=96d10418&scoped=true"
import script from "./repairDetailPhotos.vue?vue&type=script&lang=js"
export * from "./repairDetailPhotos.vue?vue&type=script&lang=js"
import style0 from "./repairDetailPhotos.vue?vue&type=style&index=0&id=96d10418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d10418",
  null
  
)

export default component.exports